import { DateTime } from 'luxon';

export const ESTADOS = [
  { valor: 'AC', rotulo: 'Acre' },
  { valor: 'AL', rotulo: 'Alagoas' },
  { valor: 'AP', rotulo: 'Amapé' },
  { valor: 'AM', rotulo: 'Amazonas' },
  { valor: 'BA', rotulo: 'Bahia' },
  { valor: 'CE', rotulo: 'Ceará' },
  { valor: 'DF', rotulo: 'Distrito Federal' },
  { valor: 'ES', rotulo: 'Espírito Santo' },
  { valor: 'GO', rotulo: 'Goiás' },
  { valor: 'MA', rotulo: 'Maranhão' },
  { valor: 'MT', rotulo: 'Mato Grosso' },
  { valor: 'MS', rotulo: 'Mato Grosso do Sul' },
  { valor: 'MG', rotulo: 'Minas Gerais' },
  { valor: 'PA', rotulo: 'Pará' },
  { valor: 'PB', rotulo: 'Paraíba' },
  { valor: 'PR', rotulo: 'Paraná' },
  { valor: 'PE', rotulo: 'Pernambuco' },
  { valor: 'PI', rotulo: 'Piauí' },
  { valor: 'RJ', rotulo: 'Rio de Janeiro' },
  { valor: 'RN', rotulo: 'Rio Grande do Norte' },
  { valor: 'RS', rotulo: 'Rio Grande do Sul' },
  { valor: 'RO', rotulo: 'Rondônia' },
  { valor: 'RR', rotulo: 'Roraima' },
  { valor: 'SC', rotulo: 'Santa Catarina' },
  { valor: 'SP', rotulo: 'São Paulo' },
  { valor: 'SE', rotulo: 'Sergipe' },
  { valor: 'TO', rotulo: 'Tocantins' },
];

export const PERMISSOES = [
  { valor: 'super', rotulo: 'Super' },
  { valor: 'admin', rotulo: 'Administrador' },
  { valor: 'comum', rotulo: 'Comum' },
];

export const PERMISSOES_OS = [
  { valor: '', rotulo: 'Sem acesso' },
  { valor: 'super', rotulo: 'Super' },
  { valor: 'admin', rotulo: 'Administrador' },
  { valor: 'tecnico', rotulo: 'Técnico' },
];

export const SEXOS = [
  { valor: 1, rotulo: 'Feminino' },
  { valor: 2, rotulo: 'Masculino' },
];

export const ESCOLARIDADES = [
  { valor: 1, rotulo: 'Ensino fundamental' },
  { valor: 2, rotulo: 'Ensino médio' },
  { valor: 3, rotulo: 'Graduação' },
  { valor: 4, rotulo: 'Especialização' },
  { valor: 5, rotulo: 'Mestrado' },
  { valor: 6, rotulo: 'Doutorado' },
  { valor: 7, rotulo: 'Pós-Doutorado' },
];

export const SIM_OU_NAO = [
  { valor: 0, rotulo: 'Não' },
  { valor: 1, rotulo: 'Sim' },
];

export const ESTADOS_CIVIS = [
  { valor: 1, rotulo: 'Casado(a)' },
  { valor: 2, rotulo: 'Divorciado(a)' },
  { valor: 3, rotulo: 'Solteiro(a)' },
  { valor: 4, rotulo: 'Separado(a)' },
  { valor: 5, rotulo: 'União estável' },
  { valor: 6, rotulo: 'Viúvo(a)' },
];

export const TIPOS_DE_CONTA = [
  { valor: 1, rotulo: 'Corrente' },
  { valor: 2, rotulo: 'Poupança' },
  { valor: 3, rotulo: 'Salário' },
];

export const NOMES_DE_ARQUIVOS = [
  { valor: 'Assinatura Digital', rotulo: 'Assinatura Digital' },
  { valor: 'Carteira de Trabalho', rotulo: 'Carteira de Trabalho' },
  { valor: 'CPF', rotulo: 'CPF' },
  { valor: 'Currículo', rotulo: 'Currículo' },
  {
    valor: 'Carteira de Vacinação dos Filhos Menores de 14 Anos',
    rotulo: 'Carteira de Vacinação dos Filhos Menores de 14 Anos',
  },
  {
    valor: 'Certidão de Casamento ou Nascimento',
    rotulo: 'Certidão de Casamento ou Nascimento',
  },
  {
    valor: 'Certidão de Nascimento dos Filhos Menores de 14 Anos',
    rotulo: 'Certidão de Nascimento dos Filhos Menores de 14 Anos',
  },
  { valor: 'Certificado de Reservista', rotulo: 'Certificado de Reservista' },
  { valor: 'Comprovante de Residência', rotulo: 'Comprovante de Residência' },
  { valor: 'Histórico Escolar', rotulo: 'Histórico Escolar' },
  { valor: 'E-Social', rotulo: 'E-Social' },
  {
    valor: 'Exame Admissional c/ Comprovante de Pagamento',
    rotulo: 'Exame Admissional c/ Comprovante de Pagamento',
  },
  { valor: 'RG', rotulo: 'RG' },
  { valor: 'Título de Eleitor', rotulo: 'Título de Eleitor' },
  { valor: 'Outro', rotulo: 'Outro' },
];

export const REGIMES_DE_TRABALHO = [
  { valor: 1, rotulo: 'Horista' },
  { valor: 2, rotulo: 'Tempo parcial' },
  { valor: 3, rotulo: 'Tempo integral' },
  { valor: 4, rotulo: 'Estagiário' },
  { valor: 5, rotulo: 'Eventual' },
  { valor: 6, rotulo: 'Comissionamento' },
];

export const FORMAS_DE_CONTRATACAO = [
  { valor: 1, rotulo: 'Hora' },
  { valor: 2, rotulo: 'Mensalista' },
  { valor: 3, rotulo: 'Comissão' },
];

const anos = [];

const anoAtual = DateTime.now().year - 20;
for (let i = anoAtual; i <= anoAtual + 60; i++) {
  anos.push({ valor: i, rotulo: i });
}

export const ANOS = anos;

export const MESES = [
  { valor: 1, rotulo: 'Janeiro' },
  { valor: 2, rotulo: 'Fevereiro' },
  { valor: 3, rotulo: 'Março' },
  { valor: 4, rotulo: 'Abril' },
  { valor: 5, rotulo: 'Maio' },
  { valor: 6, rotulo: 'Junho' },
  { valor: 7, rotulo: 'Julho' },
  { valor: 8, rotulo: 'Agosto' },
  { valor: 9, rotulo: 'Setembro' },
  { valor: 10, rotulo: 'Outubro' },
  { valor: 11, rotulo: 'Novembro' },
  { valor: 12, rotulo: 'Dezembro' },
];

export const IMAGENS = ['image/png', 'image/jpeg', 'image/webp'];

export const PDF = ['application/pdf'];

export const CURRICULOS = [
  'application/msword',
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];

export const TIPOS_HOLERITE = [
  { valor: 1, rotulo: 'Salário' },
  { valor: 2, rotulo: 'Férias' },
  { valor: 3, rotulo: 'Rescisão' },
  { valor: 4, rotulo: 'Décimo Terceiro' },
  { valor: 5, rotulo: 'PLR' },
  { valor: 6, rotulo: 'Vale/Adiantamento' },
];

export const INDISPONIBILIDADES = [
  { valor: 1, rotulo: 'Férias' },
  { valor: 2, rotulo: 'Folga' },
  { valor: 3, rotulo: 'Afastamento' },
];

export const INDISPONIBILIDADE_STATUS = [
  { valor: 3, rotulo: 'Aguardando aprovação' },
  { valor: 0, rotulo: 'Reprovado' },
  { valor: 1, rotulo: 'Aprovado' },
];

export const VINCULOS_STATUS = [
  { valor: 0, rotulo: 'Inativos' },
  { valor: 1, rotulo: 'Ativos' },
];

export const MASCARA_CPF = '000.000.000-00';

export const MASCARA_CNPJ = '00.000.000/0000-00';

export const MASCARA_TELEFONE = '(00) 0000[0]-0000';

export const MASCARA_CEP = '00000-000';
